/// <reference path="../wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.WorkViewObject";
        class WorkViewObjectWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("WorkViewObjectWidgetTypeClass.createInstance()");
                    return new WorkViewObjectWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("WorkViewObjectWidgetTypeClass._storeHtml()");
                    WorkViewObjectWidgetInstanceClass.HtmlData = htmlData;
                    if (WorkViewObjectWidgetInstanceClass.SelectionModalHtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._storeSelectionModalHtml = (htmlData) => {
                    this._log.info("WorkViewObjectWidgetTypeClass._storeSelectionModalHtml()");
                    WorkViewObjectWidgetInstanceClass.SelectionModalHtmlData = htmlData;
                    if (WorkViewObjectWidgetInstanceClass.HtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewObjectWidgetTypeClass::constructor");
                if (WorkViewObjectWidgetInstanceClass.HtmlData != null && WorkViewObjectWidgetInstanceClass.SelectionModalHtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (WorkViewObjectWidgetInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/WorkViewObject/workview-object.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (WorkViewObjectWidgetInstanceClass.SelectionModalHtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/WorkViewObject/workview-object-selection-modal.html', this._storeSelectionModalHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.WorkViewObjectWidgetTypeClass = WorkViewObjectWidgetTypeClass;
        class WorkViewObjectWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._mainDiv = null;
                this._loader = null;
                this._formHolder = null;
                this._htmlFormHolder = null;
                this._docList = null;
                this._deleteMsgHolder = null;
                this._usesDynamicTitle = null;
                this._headerTitle = null;
                this._showOptionsSpan = null;
                this._hideOptionsSpan = null;
                this._createObjectSpan = null;
                this._editObjectSpan = null;
                this._actionObjectSpan = null;
                this._deleteObjectSpan = null;
                this._cancelEditSpan = null;
                this._saveEditSpan = null;
                this._documentToggle = null;
                this._switchToDocs = null;
                this._swicthToWV = null;
                this._currentObject = null;
                this._currentActions = null;
                this._options = null;
                this._options2 = null;
                this._isHtmlForm = null;
                this._currentHtmlForm = null;
                this._breadcrumbHistory = null;
                this._breadcrumb = null;
                this._viewConfigFile = null;
                this._refreshTriggers = null;
                this._clearTriggers = null;
                this._dataList = null;
                this._actionMenu = null;
                this._attrForm = null;
                this._htmlForm = null;
                this._currentRelationSelectionModalSession = null;
                this._selectionModalSearchTitle = null;
                this._modalClose = null;
                this._reactToSlots = [];
                this._lastReactedSlots = [];
                this._cacheReady = false;
                this._pendingRequest = null;
                this._displayActionIcon = null;
                this._activateIntoDocSlot = null;
                this.presentInstance = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = WorkViewObjectWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._usesDynamicTitle = true;
                    this._hasChangedData = false;
                    this._isHtmlForm = false;
                    this._cacheReady = false;
                    this._currentHtmlForm = null;
                    this._breadcrumbHistory = [];
                    this._pendingRequest = null;
                    this._mainDiv = this._container.querySelector('#workViewObjectWidget');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._formHolder = this._container.querySelector('#workViewObjectFormHolder');
                    this._htmlFormHolder = this._container.querySelector('#workViewObjectHtmlFormHolder');
                    this._docList = this._container.querySelector('#workViewObjectDocumentList');
                    this._deleteMsgHolder = this._container.querySelector('#workViewObjectDeletedMessageHolder');
                    this._headerTitle = this._container.querySelector('#workViewObjectWidgetTitle');
                    this._showOptionsSpan = this._container.querySelector('.workViewObjectShowOptions');
                    this._hideOptionsSpan = this._container.querySelector('.workViewObjectHideOptions');
                    this._actionObjectSpan = this._container.querySelector('.workViewObjectActions');
                    this._createObjectSpan = this._container.querySelector('.workViewObjectCreate');
                    this._editObjectSpan = this._container.querySelector('.workViewObjectEdit');
                    this._deleteObjectSpan = this._container.querySelector('.workViewObjectDelete');
                    this._cancelEditSpan = this._container.querySelector('.workViewObjectCancel');
                    this._saveEditSpan = this._container.querySelector('.workViewObjectSave');
                    this._documentToggle = this._container.querySelector('.workViewObjectToggleDocuments');
                    this._switchToDocs = this._container.querySelector('.workViewObjectSwitchToDocuments');
                    this._swicthToWV = this._container.querySelector('.workViewObjectSwitchToWorkView');
                    this._options = this._container.querySelectorAll('.workViewObjectOption');
                    this._options2 = this._container.querySelectorAll('.workViewObjectOption2');
                    let reloadOption = this._container.querySelector('.workViewObjectReload');
                    this._breadcrumb = this._container.querySelector('.workViewObjectBreadcrumb');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    let conf = this._config;
                    if (conf.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers)
                        this._refreshTriggers = conf.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    if (conf.hasOwnProperty('ClearTriggers') && conf.ClearTriggers)
                        this._clearTriggers = conf.ClearTriggers;
                    else
                        this._clearTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._clearTriggers);
                    // if no title is configured, we are using a dynamic title
                    if (this._config.Title && this._config.Title.length > 0) {
                        this._usesDynamicTitle = false;
                    }
                    this._widgets.setTitle(this._config, this._headerTitle, "");
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(this._showOptionsSpan, 'title', 'STR_WPT_WV_SHOW_OPTIONS');
                    this._core.Helper.setElementTranslationAttribute(this._hideOptionsSpan, 'title', 'STR_WPT_WV_HIDE_OPTIONS');
                    this._core.Helper.setElementTranslationAttribute(this._actionObjectSpan, 'title', 'STR_WPT_WV_SHOW_ACTIONS');
                    this._core.Helper.setElementTranslationAttribute(this._createObjectSpan, 'title', 'STR_WPT_WV_CREATE_OBJECT');
                    this._core.Helper.setElementTranslationAttribute(this._editObjectSpan, 'title', 'STR_WPT_WV_MODIFY_OBJECT');
                    this._core.Helper.setElementTranslationAttribute(this._deleteObjectSpan, 'title', 'STR_WPT_WV_DELETE_OBJECT');
                    this._core.Helper.setElementTranslationAttribute(this._cancelEditSpan, 'title', 'STR_WPT_WV_CANCEL_CHANGES');
                    this._core.Helper.setElementTranslationAttribute(this._saveEditSpan, 'title', 'STR_WPT_WV_SAVE_CHANGES');
                    this._core.Helper.setElementTranslationAttribute(this._switchToDocs, 'title', 'STR_WPT_WV_SWITCH_TO_DOCUMENTS');
                    this._core.Helper.setElementTranslationAttribute(this._swicthToWV, 'title', 'STR_WPT_WV_SWITCH_TO_OBJECT');
                    this._core.Helper.setElementTranslationAttribute(reloadOption, 'title', 'STR_WPT_WV_RELOAD_OBJECT');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workViewObjectLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._deleteMsgHolder.querySelector('#workViewObjectDeletedMessageText'), 'STR_WPT_WV_DELETED');
                    this._selectionModalSearchTitle = this._core.Locale.getTranslation('STR_WPT_WV_SEARCH_RELATED_WITH');
                    this._modalClose = this._core.Locale.getTranslation('STR_WPT_CLOSE');
                    this._showOptionsSpan.addEventListener('click', this._showOptions);
                    this._hideOptionsSpan.addEventListener('click', this._hideOptions);
                    this._actionObjectSpan.addEventListener('click', this._showActions);
                    this._createObjectSpan.addEventListener('click', this._createObjectClicked);
                    this._editObjectSpan.addEventListener('click', this._editObject);
                    this._deleteObjectSpan.addEventListener('click', this._deleteObject);
                    this._cancelEditSpan.addEventListener('click', this._cancelEditing);
                    this._saveEditSpan.addEventListener('click', this._saveEditing);
                    this._documentToggle.addEventListener('click', this._toggleDocuments);
                    reloadOption.addEventListener('click', this._reloadObject);
                    this._actionMenu = new Widgets.ComponentWvActionMenu(this._core, null, this, this._actionExecuted);
                    this._actionMenu.present();
                    let callbacks = {
                        DataChangedCallback: this._dataChanged,
                        DocumentLinkCallback: this._showDocumentInViewer,
                        RelationLinkCallback: this._displayRelatedObject,
                        RelationSearchCallback: this._searchRelation
                    };
                    this._attrForm = new Widgets.ComponentWvAttributes(this._core, this._formHolder, this, callbacks);
                    this._attrForm.present();
                    let formCallbacks = {
                        DataChangedCallback: this._dataChanged,
                        DocumentLinkCallback: this._showDocumentInViewer,
                        RelationLinkCallback: this._displayRelatedObject,
                        RelationSearchCallback: this._searchRelation,
                        SaveDataCallback: this._saveObjectFromForm,
                        ActionExecutedCallback: this._actionExecuted
                    };
                    this._htmlForm = new Widgets.ComponentWvFormHandler(this._core, this._htmlFormHolder, this, formCallbacks);
                    this._htmlForm.present();
                    let listConfig = {
                        SelectItemCallback: this._docClicked
                    };
                    this._dataList = new Widgets.ComponentDataList(this._core, this._docList, this, listConfig);
                    this._dataList.present();
                    this._core.OBHelper.LoadWorkViewOverview(this._cacheUpdated);
                    if (conf.hasOwnProperty('CreateObject')) {
                        let requestObject = conf.CreateObject;
                        this._createObject(requestObject);
                    }
                    else if (conf.hasOwnProperty('DisplayObject')) {
                        let objectId = 0;
                        if (typeof (conf.DisplayObject.ObjectId) == 'number') {
                            objectId = conf.DisplayObject.ObjectId;
                        }
                        else {
                            objectId = +this._core.Context.expandMacro(conf.DisplayObject.ObjectId)[0];
                        }
                        let requestObject = {
                            Application: this._core.Context.expandMacro(conf.DisplayObject.Application)[0],
                            Class: this._core.Context.expandMacro(conf.DisplayObject.Class)[0],
                            ObjectId: objectId
                        };
                        this._displayObject(requestObject);
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this.clearView = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass.clearView()");
                    let instance = this;
                    let clearViewFn = function () {
                        instance._currentObject = null;
                        instance._hasChangedData = false;
                        instance._isHtmlForm = false;
                        instance._currentHtmlForm = null;
                        instance._attrForm.clearView();
                        instance._htmlForm.clearView();
                        instance._dataList.clearList();
                        instance._core.Functions.hideElement(instance._mainDiv);
                    };
                    this._checkEditModeAndChanges(clearViewFn.bind(this));
                };
                this._cacheUpdated = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._cacheUpdated()");
                    this._cacheReady = true;
                    if (this._pendingRequest != null) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("display pending request: (" + this._pendingRequest.isNewCreated + ", " + this._pendingRequest.prefillValues + ")");
                        }
                        this._displayWorkViewObject(this._pendingRequest.isNewCreated, this._pendingRequest.prefillValues);
                        this._pendingRequest = null;
                    }
                };
                this._displayRelatedObject = (requestObject) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._displayRelatedObject()");
                    this._displayObject(requestObject, null, true);
                };
                this._searchRelation = (attrName, requestResult, resultCallback = null) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._searchRelation()");
                    let instance = this;
                    this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, this._currentObject.Class.Application.Name, this._currentObject.Class.Name).then(function (classConfig) {
                        let filterName = null;
                        let searchAttribute = null;
                        let useLikeOperator = false;
                        let isDynamicFilter = true;
                        if (classConfig != null && classConfig.Attributes) {
                            let attrConfig = classConfig.Attributes.find(attr => attr.Name === requestResult.SearchAttribute);
                            if (attrConfig != null && attrConfig.RelationFilter) {
                                filterName = attrConfig.RelationFilter;
                                if (attrConfig.hasOwnProperty('RelationFilterLikeOperator') && attrConfig.RelationFilterLikeOperator) {
                                    useLikeOperator = true;
                                }
                                if (attrConfig.RelationFilterSearchAttribute) {
                                    searchAttribute = attrConfig.RelationFilterSearchAttribute;
                                }
                            }
                        }
                        let flexSearch = null;
                        if (filterName === null) {
                            flexSearch = {
                                SearchDefinition: {
                                    Type: "byclass",
                                    Terms: [
                                        {
                                            Term: ">>application",
                                            Value: requestResult.Application
                                        },
                                        {
                                            Term: ">>class",
                                            Value: requestResult.Class
                                        },
                                        {
                                            Term: ">>searchAttribute",
                                            Value: requestResult.SearchAttribute
                                        },
                                        {
                                            Term: ">>searchValue",
                                            Value: requestResult.SearchValue
                                        }
                                    ]
                                }
                            };
                        }
                        else {
                            isDynamicFilter = false;
                            if (searchAttribute === null) {
                                let firstDot = requestResult.SearchAttribute.indexOf('.');
                                if (firstDot != -1) {
                                    searchAttribute = requestResult.SearchAttribute.substring(firstDot + 1);
                                }
                                else {
                                    searchAttribute = "objectname";
                                    useLikeOperator = true;
                                }
                            }
                            let operator = "=";
                            let searchValue = requestResult.SearchValue;
                            if (useLikeOperator) {
                                operator = "like";
                                searchValue = "*" + requestResult.SearchValue + "*";
                            }
                            flexSearch = {
                                SearchDefinition: {
                                    Type: "byfilter",
                                    Terms: [
                                        {
                                            Term: ">>application",
                                            Value: requestResult.Application
                                        },
                                        {
                                            Term: ">>filter",
                                            Value: filterName
                                        },
                                        {
                                            Term: searchAttribute,
                                            Value: searchValue,
                                            Operator: operator
                                        }
                                    ]
                                }
                            };
                        }
                        if (requestResult.hasOwnProperty('Constraints') && requestResult.Constraints) {
                            let resultingConstraints = this._core.OBHelper.expandWorkViewConstraintMacros(requestResult.Constraints);
                            flexSearch.SearchDefinition.Terms.push(...resultingConstraints);
                        }
                        let request = JSON.stringify(flexSearch);
                        instance._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/ObjectQuery', request, instance._showRelationChooserModal.bind(instance, attrName, requestResult.SearchValue, requestResult.Application, resultCallback, isDynamicFilter), null, instance.callErrorHandler, instance.callFailedHandler);
                    });
                };
                this._showRelationChooserModal = (attrName, searchValue, application, resultCallback, isDynamicFilter, data) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("WorkViewObjectWidgetInstanceClass._showRelationChooserModal()");
                    let modalSession = 'relation-selection-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.SECOND, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentRelationSelectionModalSession = modalSession;
                        modal.DIV.innerHTML = WorkViewObjectWidgetInstanceClass.SelectionModalHtmlData;
                        let holder = modal.DIV.querySelector('#workviewObjectSelectionHolder');
                        let showFilterSpan = modal.DIV.querySelector('.workviewObjectSelectionFilter');
                        let hideFilterSpan = modal.DIV.querySelector('.workviewObjectSelectionHideFilter');
                        modal.DIV.querySelector('#workviewObjectSelectionHeading').innerHTML = this._selectionModalSearchTitle + ': "' + searchValue + '"';
                        modal.DIV.querySelector('#workviewObjectSelectionCloseButtonLabel').innerHTML = this._modalClose;
                        modal.DIV.querySelector('#closeIcon').setAttribute('title', this._modalClose);
                        modal.DIV.querySelector('#closeIcon').setAttribute('aria-label', this._modalClose);
                        this._core.Helper.setElementTranslationAttribute(showFilterSpan, 'title', 'STR_WPT_WV_FILTER_RESULT');
                        this._core.Helper.setElementTranslationAttribute(hideFilterSpan, 'title', 'STR_WPT_HIDE_FILTER');
                        let resultTable = new Widgets.ComponentWvFilterResultTable(this._core, holder, this);
                        resultTable.present();
                        let filterResult = data.FilterResult;
                        let classConfig = yield this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, application, filterResult.Class.Name);
                        let instance = this;
                        showFilterSpan.addEventListener('click', function () {
                            instance._core.Functions.hideElement(showFilterSpan);
                            instance._core.Functions.showElement(hideFilterSpan);
                            resultTable.showFilterRow();
                        });
                        hideFilterSpan.addEventListener('click', function () {
                            instance._core.Functions.hideElement(hideFilterSpan);
                            instance._core.Functions.showElement(showFilterSpan);
                            resultTable.hideFilterRow();
                        });
                        resultTable.displayFilterResult(filterResult, classConfig, null, this._relationSelected.bind(this, attrName, resultCallback), isDynamicFilter);
                        this._core.showModal(modalSession);
                    }
                });
                this._relationSelected = (attrName, resultCallback, event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._relationSelected()");
                    let clickedItem = event.currentTarget;
                    let requestObject = {
                        Application: clickedItem.getAttribute(Widgets.WV_APPLICATION_NAME_ATTRIBUTE),
                        Class: clickedItem.getAttribute(Widgets.WV_CLASS_NAME_ATTRIBUTE),
                        ObjectId: +clickedItem.getAttribute(Widgets.WV_OBJECT_ID_ATTRIBUTE)
                    };
                    if (resultCallback) {
                        resultCallback(attrName, requestObject);
                    }
                    this._core.hideModal(this._currentRelationSelectionModalSession);
                };
                this._createObject = (requestCreateObject) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._createObject()");
                    let instance = this;
                    this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, requestCreateObject.Application, requestCreateObject.Class).then(function (classConfig) {
                        if (classConfig != null && classConfig.Readonly == true) {
                            console.warn('called create WV object for readonly class');
                            instance._core.Helper.presentWarningModal('STR_WPT_WV_CREATE_READONLYCLASS_MESSAGE', 'STR_WPT_WV_CREATE_READONLYCLASS_TITLE');
                            return;
                        }
                        let createObjectFn = function () {
                            instance._core.Functions.showElement(instance._mainDiv);
                            instance._core.Functions.showElement(instance._loader);
                            instance._createObjectChecked(requestCreateObject);
                        };
                        instance._checkEditModeAndChanges(createObjectFn.bind(instance));
                    });
                };
                this._displayObject = (requestObject, appContextSlot = null, isRelated = false) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._displayObject()");
                    let instance = this;
                    let displayObjectFn = function () {
                        instance._core.Functions.showElement(instance._mainDiv);
                        instance._core.Functions.showElement(instance._loader);
                        instance._loadObject(requestObject, appContextSlot, isRelated);
                    };
                    this._checkEditModeAndChanges(displayObjectFn.bind(this));
                };
                /**
                 * Checks for changed data and warns before executing callback function.
                 */
                this._checkEditModeAndChanges = (callback) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass.checkEditModeAndChanges()");
                    if (this._hasChangedData) {
                        this._core.Helper.presentWarningContinueModal('STR_WPT_CHANGED_DATA_MESSAGE', callback, 'STR_WPT_CHANGED_DATA_TITLE');
                    }
                    else {
                        callback();
                    }
                };
                this._dataChanged = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._dataChanged()");
                    this._hasChangedData = true;
                };
                this._showDocumentInViewer = (docId) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._showDocumentInViewer()");
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = +docId;
                    navEvent.Slots.push(this._activateIntoDocSlot);
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (config.hasOwnProperty('ConditionalLaunchLayout') && config.ConditionalLaunchLayout.length > 0) {
                        let selectedDoc = this._currentObject.Documents.find(d => d.ItemNum == +docId);
                        for (let i = 0; i < config.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(config.ConditionalLaunchLayout[i].Criteria, selectedDoc, this._currentObject, navEvent)) {
                                currentConditional = config.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = "DocumentView";
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._loadObject = (requestObject, appContextSlot, isRelated) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._loadObject()");
                    let instance = this;
                    instance._isHtmlForm = false;
                    instance._currentHtmlForm = null;
                    if (!isRelated) {
                        instance._breadcrumbHistory = [];
                    }
                    else {
                        let breadcrumbIndex = instance._breadcrumbHistory.findIndex(b => (b.ObjectData.Class.Name == requestObject.Class && b.ObjectData.Id == requestObject.ObjectId));
                        if (instance._log.isTraceEnabled()) {
                            instance._log.trace("got breadcrumb index: " + breadcrumbIndex);
                        }
                        if (breadcrumbIndex > 0) {
                            // remove related object from breadcrumb history to prevent usage of old data
                            this._breadcrumbHistory.splice(breadcrumbIndex, 1);
                        }
                    }
                    this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, requestObject.Application, requestObject.Class).then(function (classConfig) {
                        let formId = null;
                        if (classConfig != null) {
                            if (classConfig.Form) {
                                formId = classConfig.Form;
                                appContextSlot = null;
                                instance._isHtmlForm = true;
                            }
                            if (classConfig.Attributes) {
                                requestObject.RequestedAttributes = classConfig.Attributes.map(attr => attr.Name);
                                appContextSlot = null;
                            }
                        }
                        if (appContextSlot) {
                            instance._log.trace("using application context");
                            instance._presentWorkViewObject(false, instance._core.Context.getWvObjectFromSlot(appContextSlot));
                        }
                        else {
                            if (instance._isHtmlForm) {
                                instance._log.trace("requesting WV HTML form");
                                instance._core.Helper.getWvFormForId(formId).then(function (formData) {
                                    instance._log.trace("got WV HTML form");
                                    instance._currentHtmlForm = formData;
                                    requestObject.RequestedAttributes = WPTNamespace.Utilities.WvForms.WvFormHelper.getFormAttributes(formData);
                                    instance._log.trace("requesting WV object based on form attributes");
                                    let request = JSON.stringify(requestObject);
                                    instance._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetObject', request, instance._presentObjectData, null, instance.callErrorHandler, instance.callFailedHandler);
                                });
                            }
                            else {
                                instance._log.trace("requesting WV object");
                                let request = JSON.stringify(requestObject);
                                instance._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetObject', request, instance._presentObjectData, null, instance.callErrorHandler, instance.callFailedHandler);
                            }
                        }
                    });
                };
                this._createObjectChecked = (requestCreateObject) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._createObject()");
                    let instance = this;
                    instance._isHtmlForm = false;
                    instance._currentHtmlForm = null;
                    instance._breadcrumbHistory = [];
                    this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, requestCreateObject.Application, requestCreateObject.Class).then(function (classConfig) {
                        let formId = null;
                        if (classConfig != null) {
                            if (classConfig.Form) {
                                formId = classConfig.Form;
                                instance._isHtmlForm = true;
                            }
                            if (classConfig.Attributes) {
                                requestCreateObject.RequestedAttributes = classConfig.Attributes.map(attr => attr.Name);
                            }
                        }
                        if (instance._isHtmlForm) {
                            instance._log.trace("requesting WV HTML form");
                            instance._core.Helper.getWvFormForId(formId).then(function (formData) {
                                instance._log.trace("got WV HTML form");
                                instance._currentHtmlForm = formData;
                                requestCreateObject.RequestedAttributes = WPTNamespace.Utilities.WvForms.WvFormHelper.getFormAttributes(formData);
                                instance._log.trace("creating WV object based on form attributes");
                                let request = JSON.stringify(requestCreateObject);
                                instance._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/CreateObject', request, instance._presentCreateObjectData, null, instance.callErrorHandler, instance.callFailedHandler);
                            });
                        }
                        else {
                            instance._log.trace("creating WV object");
                            let request = JSON.stringify(requestCreateObject);
                            instance._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/CreateObject', request, instance._presentCreateObjectData, null, instance.callErrorHandler, instance.callFailedHandler);
                        }
                    });
                };
                this._objectUpdated = (objectData) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._objectUpdated()");
                    let breadcrumbIndex = this._breadcrumbHistory.findIndex(b => (b.ObjectData.Class.Name == objectData.Object.Class.Name && b.ObjectData.Id == objectData.Object.Id));
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got breadcrumb index: " + breadcrumbIndex);
                    }
                    if (breadcrumbIndex >= 0) {
                        let isRelated = breadcrumbIndex != 0;
                        if (!isRelated) {
                            this._breadcrumbHistory = [];
                        }
                        else {
                            // remove related object from breadcrumb history to prevent usage of old data
                            this._breadcrumbHistory.splice(breadcrumbIndex, 1);
                        }
                    }
                    this._presentWorkViewObject(false, objectData.Object);
                    let requestObject = {
                        Application: objectData.Object.Class.Application.Name,
                        Class: objectData.Object.Class.Name,
                        ObjectId: objectData.Object.Id
                    };
                    let conf = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_UPDATED);
                    navEvent.ActivationID = requestObject.ObjectId;
                    navEvent.PrimaryContext = requestObject;
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (conf.hasOwnProperty('ConditionalLaunchLayout') && conf.ConditionalLaunchLayout.length > 0) {
                        for (let i = 0; i < conf.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(conf.ConditionalLaunchLayout[i].Criteria, null, objectData.Object, navEvent)) {
                                currentConditional = conf.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = this._currentLayout;
                        if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                            if (conf.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = conf.LaunchLayout;
                        }
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (conf.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(conf.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._presentObjectData = (objectData) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._presentObjectData()");
                    this._presentWorkViewObject(false, objectData.Object);
                };
                this._presentCreateObjectData = (objectData) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._presentCreateObjectData()");
                    // not using LayoutActivationType "WV_OBJECT_CREATED" on purpose (object is created, but without proper values, use "WV_OBJECT_UPDATED" instead)
                    this._presentWorkViewObject(true, objectData.Object);
                };
                this._presentWorkViewObject = (isNewCreated = false, objectData) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._presentWorkViewObject()");
                    this._currentObject = objectData;
                    this._currentActions = this._core.OBHelper.WorkViewActions.filter((wva) => { return wva.Application == objectData.Class.Application.Name && wva.Class == objectData.Class.Name; });
                    this._hasChangedData = false;
                    let prefillValues = [];
                    this._core.Functions.hideElement(this._loader);
                    let instance = this;
                    this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, objectData.Class.Application.Name, objectData.Class.Name).then(function (classConfig) {
                        var _a;
                        if (classConfig != null) {
                            if (classConfig.hasOwnProperty('Readonly') && classConfig.Readonly) {
                                instance._currentObject.Class.Readonly = true;
                            }
                            if (classConfig.hasOwnProperty('Attributes') && instance._currentObject.hasOwnProperty('Values') && instance._currentObject.Values.length > 0) {
                                let valuesLength = instance._currentObject.Values.length;
                                for (let v = 0; v < valuesLength; v++) {
                                    let attribute = instance._currentObject.Values[v];
                                    let attrName = attribute.Name;
                                    if ((_a = attribute.Relation) === null || _a === void 0 ? void 0 : _a.RequestedName) {
                                        attrName = attribute.Relation.RequestedName;
                                    }
                                    let attrConfig = classConfig.Attributes.find(attr => attr.Name == attrName);
                                    if (attrConfig != null && attrConfig != undefined) {
                                        if (attrConfig.hasOwnProperty('Readonly') && attrConfig.Readonly) {
                                            attribute.Readonly = true;
                                        }
                                        if (attrConfig.hasOwnProperty('Required') && attrConfig.Required) {
                                            attribute.Required = true;
                                        }
                                        if (attrConfig.hasOwnProperty('DisplayName') && attrConfig.DisplayName.length > 0) {
                                            attribute.DisplayName = instance._core.Locale.getTranslation(attrConfig.DisplayName);
                                            if (instance._log.isTraceEnabled()) {
                                                instance._log.trace("added display name: " + attribute.DisplayName);
                                            }
                                        }
                                        if (attrConfig.hasOwnProperty('Dataset') && attrConfig.Dataset.length > 0) {
                                            attribute.Dataset = attrConfig.Dataset;
                                            if (instance._log.isTraceEnabled()) {
                                                instance._log.trace("added dataset: " + attribute.Dataset);
                                            }
                                        }
                                        if (isNewCreated && attrConfig.hasOwnProperty('PrefillValue') && attrConfig.PrefillValue.length > 0) {
                                            if ((attribute.Relation && attribute.Relation.RelatedId == 0) || (!attribute.Relation && attribute.Value == "")) {
                                                let values = instance._core.Context.expandMacro(attrConfig.PrefillValue);
                                                if (values.length > 0 && values[0] != WPTNamespace.Utilities.BLOCKED_VALUE) {
                                                    let prefillAttribute = JSON.parse(JSON.stringify(attribute));
                                                    prefillAttribute.Value = values[0];
                                                    prefillValues.push(prefillAttribute);
                                                    if (instance._log.isTraceEnabled()) {
                                                        instance._log.trace("added prefill: " + prefillAttribute.Name + " = " + prefillAttribute.Value);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (classConfig.hasOwnProperty('Actions') && classConfig.Actions.length > 0) {
                                classConfig.Actions.forEach(action => {
                                    if (action.hasOwnProperty('DisplayName') && action.DisplayName.length > 0) {
                                        let act = instance._currentActions.find(a => a.Name == action.Name);
                                        if (act) {
                                            act.DisplayName = instance._core.Locale.getTranslation(action.DisplayName);
                                        }
                                    }
                                }, instance);
                            }
                        }
                        let optionsLength = instance._options.length;
                        for (let i = 0; i < optionsLength; i++) {
                            let option = instance._options[i];
                            instance._core.Functions.hideElement(option);
                        }
                        let options2Length = instance._options2.length;
                        for (let i = 0; i < options2Length; i++) {
                            let option2 = instance._options2[i];
                            instance._core.Functions.hideElement(option2);
                        }
                        instance._core.Functions.hideElement(instance._hideOptionsSpan);
                        instance._core.Functions.showElement(instance._showOptionsSpan);
                        if (!instance._currentObject.Class.Readonly && !instance._isHtmlForm) {
                            instance._core.Functions.showElement(instance._editObjectSpan);
                        }
                        if (instance._displayActionIcon && instance._currentActions.length > 0) {
                            instance._core.Functions.showElement(instance._actionObjectSpan);
                        }
                        if (instance._isHtmlForm) {
                            instance._core.Functions.showElement(instance._htmlFormHolder);
                            instance._core.Functions.hideElement(instance._formHolder);
                            instance._attrForm.clearView();
                        }
                        else {
                            instance._core.Functions.showElement(instance._formHolder);
                            instance._core.Functions.hideElement(instance._htmlFormHolder);
                            instance._htmlForm.clearView();
                        }
                        instance._core.Functions.showElement(instance._switchToDocs);
                        instance._core.Functions.hideElement(instance._swicthToWV);
                        instance._core.Functions.hideElement(instance._docList);
                        instance._core.Functions.hideElement(instance._deleteMsgHolder);
                        let breadcrumbIndex = instance._breadcrumbHistory.findIndex(b => (b.ObjectData.Class.Name == objectData.Class.Name && b.ObjectData.Id == objectData.Id));
                        if (instance._log.isTraceEnabled()) {
                            instance._log.trace("got breadcrumb index: " + breadcrumbIndex);
                        }
                        if (breadcrumbIndex == -1) {
                            let newEntry = {
                                ObjectData: objectData,
                                FormData: instance._currentHtmlForm,
                                IsFormBased: instance._isHtmlForm
                            };
                            instance._breadcrumbHistory.push(newEntry);
                            breadcrumbIndex = instance._breadcrumbHistory.length - 1;
                        }
                        instance._breadcrumb.innerHTML = "";
                        if (instance._breadcrumbHistory.length > 1) {
                            instance._core.Functions.showElement(instance._breadcrumb);
                            let breadcrumbList = document.createElement('ul');
                            instance._breadcrumb.appendChild(breadcrumbList);
                            let objectLength = instance._breadcrumbHistory.length;
                            for (let o = 0; o < objectLength; o++) {
                                let entry = instance._breadcrumbHistory[o];
                                let breadcrumbItem = document.createElement('li');
                                breadcrumbList.appendChild(breadcrumbItem);
                                breadcrumbItem.addEventListener('click', instance._switchToBreadcrumbEntry.bind(instance, entry));
                                if (breadcrumbIndex == o) {
                                    breadcrumbItem.classList.add('currentObject');
                                }
                                let objectInfoName = "";
                                if (entry.ObjectData.Name != null && entry.ObjectData.Name != undefined && entry.ObjectData.Name.length > 0) {
                                    objectInfoName = entry.ObjectData.Name;
                                }
                                else {
                                    objectInfoName = entry.ObjectData.Class.Name + " | " + entry.ObjectData.Id;
                                }
                                breadcrumbItem.appendChild(document.createTextNode(objectInfoName));
                            }
                        }
                        else {
                            instance._core.Functions.hideElement(instance._breadcrumb);
                        }
                        if (instance._usesDynamicTitle) {
                            instance._core.Widgets.setTitle(instance._config, instance._headerTitle, "");
                            instance._headerTitle.setAttribute("title", "");
                            let objectInfoName = "";
                            if (instance._currentObject.Name != null && instance._currentObject.Name != undefined && instance._currentObject.Name.length > 0) {
                                objectInfoName = instance._currentObject.Name;
                            }
                            else {
                                let classLabel = instance._currentObject.Class.Name;
                                if (classConfig && classConfig.hasOwnProperty('DisplayName') && classConfig.DisplayName.length > 0) {
                                    classLabel = instance._core.Locale.getTranslation(classConfig.DisplayName);
                                }
                                objectInfoName = classLabel + " | " + instance._currentObject.Id;
                            }
                            instance._core.Widgets.setTitle(instance._config, instance._headerTitle, objectInfoName);
                            instance._headerTitle.setAttribute("title", objectInfoName);
                        }
                        if (instance._cacheReady) {
                            instance._displayWorkViewObject(isNewCreated, prefillValues);
                        }
                        else {
                            instance._pendingRequest = { isNewCreated: isNewCreated, prefillValues: prefillValues };
                        }
                    });
                };
                this._displayWorkViewObject = (isNewCreated, prefillValues) => {
                    if (this._isHtmlForm) {
                        this._htmlForm.showObject(this._currentHtmlForm, this._currentObject, prefillValues);
                    }
                    else {
                        if (this._currentObject.hasOwnProperty('Values') && this._currentObject.Values.length > 0) {
                            this._attrForm.displayAttributes(this._currentObject);
                        }
                        else {
                            console.warn("Widgets.WorkViewObjectWidgetInstanceClass._displayWorkViewObject: NO DATA");
                        }
                    }
                    this._dataList.clearList();
                    if (this._currentObject.hasOwnProperty('Documents') && this._currentObject.Documents.length > 0) {
                        this._core.Functions.showElement(this._documentToggle);
                        let listData = {
                            Items: []
                        };
                        let docLength = this._currentObject.Documents.length;
                        for (let d = 0; d < docLength; d++) {
                            let doc = this._currentObject.Documents[d];
                            let itemData = {
                                Id: doc.ItemNum.toString(10),
                                DisplayName: doc.Name
                            };
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        this._core.Functions.hideElement(this._documentToggle);
                    }
                    if (isNewCreated) {
                        if (!this._isHtmlForm) {
                            // when creating a new object, switch to edit mode and make sure object is saved (otherwise inactive object...)
                            this._editObject(null);
                            if (prefillValues.length > 0) {
                                this._attrForm.prefillAttributes(prefillValues);
                            }
                        }
                        this._dataChanged();
                    }
                };
                this._switchToBreadcrumbEntry = (entry) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._switchToBreadcrumbEntry()");
                    let instance = this;
                    let switchFunction = function () {
                        instance._currentObject = entry.ObjectData;
                        instance._currentHtmlForm = entry.FormData;
                        instance._isHtmlForm = entry.IsFormBased;
                        instance._presentWorkViewObject(false, instance._currentObject);
                    };
                    this._checkEditModeAndChanges(switchFunction);
                };
                this._showOptions = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._showOptions()");
                    this._core.Functions.hideElement(this._showOptionsSpan);
                    this._core.Functions.showElement(this._hideOptionsSpan);
                    let optionsLength = this._options.length;
                    for (let o = 0; o < optionsLength; o++) {
                        let option = this._options[o];
                        if (option.classList.contains('workViewObjectEdit')) {
                            if (!this._currentObject.Class.Readonly && !this._isHtmlForm) {
                                this._core.Functions.showElement(option);
                            }
                        }
                        else if (option.classList.contains('workViewObjectCreate') || option.classList.contains('workViewObjectDelete')) {
                            if (!this._currentObject.Class.Readonly) {
                                this._core.Functions.showElement(option);
                            }
                        }
                        else if (option.classList.contains('workViewObjectActions')) {
                            if (this._displayActionIcon && this._currentActions.length > 0) {
                                this._core.Functions.showElement(option);
                            }
                        }
                        else {
                            this._core.Functions.showElement(option);
                        }
                    }
                    let options2Length = this._options2.length;
                    for (let o = 0; o < options2Length; o++) {
                        let option2 = this._options2[o];
                        this._core.Functions.hideElement(option2);
                    }
                };
                this._hideOptions = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._hideOptions()");
                    event.preventDefault();
                    this._core.Functions.showElement(this._showOptionsSpan);
                    this._core.Functions.hideElement(this._hideOptionsSpan);
                    let optionsLength = this._options.length;
                    for (let o = 0; o < optionsLength; o++) {
                        let option = this._options[o];
                        this._core.Functions.hideElement(option);
                    }
                    let options2Length = this._options2.length;
                    for (let o = 0; o < options2Length; o++) {
                        let option2 = this._options2[o];
                        this._core.Functions.hideElement(option2);
                    }
                    if (!this._currentObject.Class.Readonly && !this._isHtmlForm) {
                        this._core.Functions.showElement(this._editObjectSpan);
                    }
                    if (this._displayActionIcon && this._currentActions.length > 0) {
                        this._core.Functions.showElement(this._actionObjectSpan);
                    }
                };
                this._showActions = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._showActions()");
                    this._actionMenu.displayActionMenu(this._currentActions, this._currentObject);
                };
                this._reloadObject = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._reloadObject()");
                    if (event != null) {
                        event.preventDefault();
                    }
                    let requestObject = {
                        Application: this._currentObject.Class.Application.Name,
                        Class: this._currentObject.Class.Name,
                        ObjectId: this._currentObject.Id
                    };
                    let breadcrumbIndex = this._breadcrumbHistory.findIndex(b => (b.ObjectData.Class.Name == requestObject.Class && b.ObjectData.Id == requestObject.ObjectId));
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got breadcrumb index: " + breadcrumbIndex);
                    }
                    let isRelated = breadcrumbIndex != 0;
                    this._displayObject(requestObject, null, isRelated);
                };
                this._createObjectClicked = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._createObjectClicked()");
                    event.preventDefault();
                    let requestObject = {
                        Application: this._currentObject.Class.Application.Name,
                        Class: this._currentObject.Class.Name
                    };
                    this._createObject(requestObject);
                };
                this._editObject = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._editObject()");
                    if (event != null) {
                        event.preventDefault();
                    }
                    this._core.Functions.hideElement(this._showOptionsSpan);
                    this._core.Functions.hideElement(this._hideOptionsSpan);
                    let optionsLength = this._options.length;
                    for (let o = 0; o < optionsLength; o++) {
                        let option = this._options[o];
                        this._core.Functions.hideElement(option);
                    }
                    this._core.Functions.showElement(this._saveEditSpan);
                    this._core.Functions.showElement(this._cancelEditSpan);
                    this._core.Functions.hideElement(this._documentToggle);
                    this._core.Functions.showElement(this._formHolder);
                    this._core.Functions.showElement(this._switchToDocs);
                    this._core.Functions.hideElement(this._swicthToWV);
                    this._core.Functions.hideElement(this._docList);
                    this._core.Functions.hideElement(this._deleteMsgHolder);
                    this._switchToEditing();
                };
                this._switchToEditing = () => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._switchToEditing()");
                    this._attrForm.switchToEditing();
                };
                this._deleteObject = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._deleteObject()");
                    event.preventDefault();
                    var requestDeletion = {
                        Application: this._currentObject.Class.Application.Name,
                        Class: this._currentObject.Class.Name,
                        ObjectId: this._currentObject.Id
                    };
                    this._core.Helper.presentWarningContinueModal('STR_WPT_WV_DELETE_MESSAGE', this._deleteObjectCall.bind(this, requestDeletion), 'STR_WPT_WV_DELETE_TITLE');
                };
                this._deleteObjectCall = (requestDeletion) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._deleteObjectCall()");
                    let request = JSON.stringify(requestDeletion);
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/DeleteObject', request, this._objectDeleted.bind(this, requestDeletion), null, this.callErrorHandler, this.callFailedHandler);
                };
                this._objectDeleted = (requestDeletion) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._objectDeleted()");
                    this._core.Functions.hideElement(this._showOptionsSpan);
                    this._core.Functions.hideElement(this._hideOptionsSpan);
                    let optionsLength = this._options.length;
                    for (let o = 0; o < optionsLength; o++) {
                        let option = this._options[o];
                        this._core.Functions.hideElement(option);
                    }
                    let options2Length = this._options2.length;
                    for (let o = 0; o < options2Length; o++) {
                        let option2 = this._options2[o];
                        this._core.Functions.hideElement(option2);
                    }
                    if (!this._currentObject.Class.Readonly) {
                        this._core.Functions.showElement(this._createObjectSpan);
                    }
                    this._core.Functions.showElement(this._deleteMsgHolder);
                    this._core.Functions.hideElement(this._formHolder);
                    this._core.Functions.hideElement(this._docList);
                    let conf = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DELETED);
                    navEvent.ActivationID = requestDeletion.ObjectId;
                    navEvent.PrimaryContext = requestDeletion;
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (conf.hasOwnProperty('ConditionalLaunchLayout') && conf.ConditionalLaunchLayout.length > 0) {
                        for (let i = 0; i < conf.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(conf.ConditionalLaunchLayout[i].Criteria, null, this._currentObject, navEvent)) {
                                currentConditional = conf.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = this._currentLayout;
                        if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                            if (conf.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = conf.LaunchLayout;
                        }
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (conf.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(conf.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._cancelEditing = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._cancelEditing()");
                    event.preventDefault();
                    this._checkEditModeAndChanges(this._presentWorkViewObject.bind(this, false, this._currentObject));
                };
                this._saveEditing = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._saveEditing()");
                    event.preventDefault();
                    let changedValues = this._attrForm.getChangedValues();
                    if (changedValues !== null) {
                        let requestData = {
                            Application: this._currentObject.Class.Application.Name,
                            Class: this._currentObject.Class.Name,
                            ObjectId: this._currentObject.Id,
                            Values: changedValues,
                            RequestedAttributes: []
                        };
                        let instance = this;
                        this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, requestData.Application, requestData.Class).then(function (classConfig) {
                            if (classConfig != null && classConfig.Attributes) {
                                requestData.RequestedAttributes = classConfig.Attributes.map(attr => attr.Name);
                            }
                            let request = JSON.stringify(requestData);
                            instance._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/UpdateObject', request, instance._objectUpdated, null, instance.callErrorHandler, instance.callFailedHandler);
                        });
                    }
                };
                this._saveObjectFromForm = (values) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._saveObjectFromForm()");
                    let requestData = {
                        Application: this._currentObject.Class.Application.Name,
                        Class: this._currentObject.Class.Name,
                        ObjectId: this._currentObject.Id,
                        Values: values,
                        RequestedAttributes: WPTNamespace.Utilities.WvForms.WvFormHelper.getFormAttributes(this._currentHtmlForm)
                    };
                    let request = JSON.stringify(requestData);
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/UpdateObject', request, this._objectUpdated, null, this.callErrorHandler, this.callFailedHandler);
                };
                this._toggleDocuments = (event) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._toggleDocuments()");
                    event.preventDefault();
                    if (this._isHtmlForm) {
                        this._htmlFormHolder.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                    }
                    else {
                        this._formHolder.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                    }
                    this._switchToDocs.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                    this._docList.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                    this._swicthToWV.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                };
                this._docClicked = (id) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._docClicked()");
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(id);
                    this._showDocumentInViewer(id);
                };
                this._actionExecuted = (request) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass._actionExecuted()");
                    this._reloadObject(null);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_ACTION_FIRED);
                    navEvent.ActivationID = request.ObjectId;
                    navEvent.PrimaryContext = request;
                    let conf = this._config;
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (conf.hasOwnProperty('ConditionalLaunchLayout') && conf.ConditionalLaunchLayout.length > 0) {
                        for (let i = 0; i < conf.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(conf.ConditionalLaunchLayout[i].Criteria, null, this._currentObject, navEvent)) {
                                currentConditional = conf.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = this._currentLayout;
                        if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                            if (conf.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = conf.LaunchLayout;
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this.callFailedHandler = (json) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass.callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this.callErrorHandler = (url, status, message) => {
                    this._log.info("WorkViewObjectWidgetInstanceClass.callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewObjectWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (conf.hasOwnProperty("ReactToSlots") && (conf.ReactToSlots != null))
                    this._reactToSlots = conf.ReactToSlots;
                else
                    this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                if (conf.hasOwnProperty('ActivateIntoDocSlot') && conf.ActivateIntoDocSlot) {
                    this._activateIntoDocSlot = conf.ActivateIntoDocSlot;
                }
                else {
                    this._activateIntoDocSlot = WPTNamespace.Utilities.PRIMARY_SLOT_KEY;
                }
                if (conf.hasOwnProperty('ViewConfiguration') && conf.ViewConfiguration) {
                    this._viewConfigFile = conf.ViewConfiguration;
                }
                else {
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('WorkViewViewConfiguration') && appConfig.WorkViewViewConfiguration) {
                        this._viewConfigFile = appConfig.WorkViewViewConfiguration;
                    }
                }
                if (conf.hasOwnProperty('ShowActionsButton') && conf.ShowActionsButton != null && conf.ShowActionsButton != undefined) {
                    this._displayActionIcon = conf.ShowActionsButton;
                }
                else {
                    this._displayActionIcon = true;
                }
            }
            setCurrentLayout(layout) {
                this._log.info("WorkViewObjectWidgetInstanceClass.setCurrentLayout()");
                super.setCurrentLayout(layout);
                if (layout == "[[-CACHE-]]" || layout == "[[-FREEZER-]]")
                    return;
                this._htmlForm.resetWvformWindow();
            }
            activate(context) {
                this._log.info("WorkViewObjectWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (slots.length > 0) {
                            // only remember slots we react to
                            this._lastReactedSlots = slots;
                            this._displayObject(context.PrimaryContext, this._lastReactedSlots[0]);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this.clearView();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WV_CLASS_SELECTED:
                        this._createObject(context.PrimaryContext);
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at refresh triggers: " + JSON.stringify(this._refreshTriggers));
                            }
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this._reloadObject(null);
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        if (this._clearTriggers.length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at clear triggers: " + JSON.stringify(this._clearTriggers));
                            }
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._clearTriggers.length; i++) {
                                let trigger = this._clearTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this.clearView();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        WorkViewObjectWidgetInstanceClass.HtmlData = null;
        WorkViewObjectWidgetInstanceClass.SelectionModalHtmlData = null;
        Widgets.WorkViewObjectWidgetInstanceClass = WorkViewObjectWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
